import moment from 'moment';
import ProfileCareerForm from '@/components/Forms/ProfileCareerForm';
import { DATE_REQUEST } from '@/helpers/common';
import { useCreateCareer } from '@/query/queries/user/useCreateCareer';
import { useUpdateCareer } from '@/query/queries/user/useUpdateCareer';
import { useDeleteCareer } from '@/query/queries/user/useDeleteCareer';

const ProfileCareerModal = ({ onClose, career }) => {
  const { mutateAsync: createCareer } = useCreateCareer();
  const { mutateAsync: updateCareer } = useUpdateCareer();
  const { mutateAsync: deleteCareer } = useDeleteCareer();

  const onSubmit = async values => {
    const payload = {
      company: values.company,
      position: values.position,
      start_date: moment(values.start_date).format(DATE_REQUEST),
      end_date: values.end_date ? moment(values.end_date).format(DATE_REQUEST) : null,
      is_working: !values.end_date,
    };

    const res = career ? await updateCareer({ id: career.id, payload }) : await createCareer(payload);
    res && onClose();
  };

  const onRemove = async () => {
    try {
      if (career) {
        const res = await deleteCareer({ careers: [career.id] });
          res && onClose();
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  return (
    <ProfileCareerForm career={career} onSubmit={onSubmit} onRemove={onRemove} onCancel={onClose} />
  );
};

export default ProfileCareerModal;
